var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSurgicalWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surgical"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8050_71307",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8050_71307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "surgical_2",
    d: "M10.3333 12.7917L7.20825 9.66667L14.1249 2.75C14.2916 2.58333 14.4895 2.5 14.7187 2.5C14.9478 2.5 15.1458 2.58333 15.3124 2.75L17.2499 4.6875C17.4166 4.85417 17.4999 5.05208 17.4999 5.28125C17.4999 5.51042 17.4166 5.70833 17.2499 5.875L10.3333 12.7917ZM9.16658 17.5L10.8333 15.8333H18.3333V17.5H9.16658ZM4.22909 17.5C3.5902 17.5 2.97561 17.375 2.38534 17.125C1.79506 16.875 1.2777 16.5278 0.833252 16.0833L6.35408 10.5833L8.52075 12.75C8.7152 12.9444 8.86797 13.1667 8.97909 13.4167C9.0902 13.6667 9.14575 13.9306 9.14575 14.2083C9.14575 14.4861 9.0902 14.7535 8.97909 15.0104C8.86797 15.2674 8.7152 15.4931 8.52075 15.6875L8.12492 16.0833C7.68047 16.5278 7.16311 16.875 6.57284 17.125C5.98256 17.375 5.36797 17.5 4.72909 17.5H4.22909Z",
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurgicalWhite);
export default __webpack_public_path__ + "static/media/surgical_white.90a3debe97769c17a6c03eac89331a51.svg";
export { ForwardRef as ReactComponent };